// ─────────────────────────────────────────────────────────────────────────────
// AddNodeButton — the primary "Add Node" action. Lives here rather than in a
// view folder because both toolbars (MapToolbar and ListToolbar) show it, and
// it must look and behave identically in each.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./AddNodeButton.module.css";

const PlusIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default function AddNodeButton({ onClick }) {
  return (
    <button type="button" className={styles.btn} onClick={onClick}>
      <PlusIcon /> Add Node
    </button>
  );
}
